import { createRouter, createWebHistory } from 'vue-router';

import BotView from './views/BotView.vue';
import ErrorView from './views/ErrorView.vue';

// let base = '/';
let base = '/bot/';

export const router = createRouter({
  history: createWebHistory(),
  base: base,
  scrollBehavior(to, from, savedPosition) {
    return { left: 0, top: 0 };
  },
  routes: [
    {
      path: base + ':botAddress',
      name: 'bot',
      component: BotView,
    },
    {
      path: base + 'error',
      name: 'error',
      component: ErrorView,
    },
    {
      path: base + ':pathMatch(.*)*',
      name: 'notFound',
      component: ErrorView,
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'noMatch',
      component: ErrorView,
    },
  ],
});
